module.exports = __webpack_public_path__ + "img/proses_stidest_sc.c9263a2f.svg";